import React, { useEffect, useState } from 'react';
import { getLinksFromSefaria } from '../../services/sefaria.service';

const SefariaCommentary = ({ sourceText, selectedVerse }) => {
  const [links, setLinks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!sourceText || !selectedVerse) {
      setLoading(true);
      setError(false);

      const response = getLinksFromSefaria(selectedVerse).then(response => {
        setLinks(response);
        setLoading(false);
      }).catch(error => {
        setError(true);
        setLoading(false);
      });
    }
  }, [sourceText, selectedVerse]);

  return (
    <div className="commentary-section">
      <div className="commentary-section-header">Sefaria Commentary</div>
      {loading && <p className="commentary-loading">Loading...</p>}
      {error && <p className="commentary-empty">Could not load Sefaria commentary.</p>}
      {!loading && !error && links.length === 0 && (
        <p className="commentary-empty">No related texts found.</p>
      )}
      {links.map((link, index) => (
        <div key={index} className="commentary-box">
          <div className="commentary-title">{link.collectiveTitle?.en || link.ref}</div>
          {link.he && (
            <div className="commentary-text commentary-text--hebrew"
              dangerouslySetInnerHTML={{ __html: link.he }}
            />
          )}
          {link.text && (
            <div className="commentary-text"
              dangerouslySetInnerHTML={{ __html: link.text }}
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default SefariaCommentary;
